import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppLoadService } from './app-load.service';
import { AppSettings } from './app-settings';
import { LoadingComponent } from '../components/loading/loading.component';
import { CommonModule } from '@angular/common';

export function getAppSettings(appLoadService: AppLoadService) {

    return () => appLoadService.getSettings();
}

@NgModule({
    declarations: [
       LoadingComponent
    ],
    imports: [
        HttpClientModule,
        CommonModule
    ],
    providers: [
        AppLoadService,
        AppSettings,
        {
            provide: APP_INITIALIZER,
            useFactory: getAppSettings,
            deps: [AppLoadService, AppSettings],
            multi: true
        }
    ],
    exports: [
        LoadingComponent
    ],
})
export class AppLoadModule { }
